export enum BreakpointSize {
  s = 540,
  m = 768,
  l = 1040,
  xl = 1440,
  xxl = 1650,
  xxxl = 1920,
}

enum BreakpointTypes {
  up = "min-width",
  down = "max-width",
}

export const breakpoint = (
  size: keyof typeof BreakpointSize,
  type: keyof typeof BreakpointTypes
) => {
  let breakpointSize: BreakpointSize = BreakpointSize[size];
  if (type === "up") {
    breakpointSize = breakpointSize + 1;
  }
  return `@media (${BreakpointTypes[type]}: ${breakpointSize}px)`;
};
